import { ChartLabels } from 'components/charts/types'
import { CoreAnnotationOptions } from 'chartjs-plugin-annotation'

/**
 * Generate annotation object for alternating background columns
 * @param {ChartLabels} labels
 */
export const getAlternatingBackground = (labels: ChartLabels, color: string) => {
  // Create array of the amount of labels and generate background shapes
  return Array.from(Array(labels.length).keys()).reduce((prev: { [key: string]: CoreAnnotationOptions }, curr) => {
    // ignore uneven entries (array starts at 0)
    if (curr % 2) {
      return prev
    }

    // create background shape object
    const backgroundShape = {
      type: 'box',
      backgroundColor: color,
      borderWidth: 0,
      xMax: 0.5 + curr,
      xMin: -0.5 + curr
    }
    return { ...prev, [curr]: backgroundShape }
  }, {}) as CoreAnnotationOptions
}
